document.addEventListener("DOMContentLoaded", initBrands);

function initBrands() {
  const switchEl = document.getElementById("origin-filter-switch");
  const blob     = switchEl.querySelector(".lang_switch__blobs");
  const cards    = Array.from(document.querySelectorAll(".brand-origin"));
  const items    = [];
  let current;

  // 1) Build map of origin→label
  const originMap = {};
  cards.forEach(card => {
    const key   = card.dataset.origin.trim().toLowerCase();
    const label = card.dataset.originLabel.trim();
    if (key) originMap[key] = label;
  });

  // 2) Sort keys, pin USA after All
  const allKeys = Object.keys(originMap);
  const others  = allKeys
    .filter(k => k !== "usa")
    .sort((a, b) => originMap[a].localeCompare(originMap[b]));
  const orderedKeys = []; // ["all"];
  if (allKeys.includes("usa")) orderedKeys.push("usa");
  orderedKeys.push(...others);

  // 3) Create filter pills
  orderedKeys.forEach((key, idx) => {
    const btn = document.createElement("div");
    btn.classList.add("lang_switch__text");
    btn.dataset.origin = key;
    btn.textContent   = key === "all" ? "All" : originMap[key];
    if (idx === 0) {
      btn.classList.add("active");
      current = btn;
    }
    switchEl.appendChild(btn);
    items.push(btn);
  });

  // 4) Animate cards function (with kill + reset)
  function animateCards(list) {
    // a) kill any existing tweens on every card
    gsap.killTweensOf(cards);

    // b) clear inline transform/opacity so we start from a clean slate
    gsap.set(cards, {
      clearProps: "transform,opacity"
    });

    // c) animate in from zero
    gsap.fromTo(
      list,
      { scale: 0, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.07,
        ease: "elastic.out(1, 0.5)"
      }
    );
  }

  // 5) Blob mover
  function moveBlob(target, scale = 1) {
    const sw   = switchEl.getBoundingClientRect();
    const tg   = target.getBoundingClientRect();
    const padX = parseInt(getComputedStyle(switchEl).paddingLeft, 10);
    const padY = parseInt(getComputedStyle(switchEl).paddingTop,  10);

    blob.style.setProperty("--translateX", `${tg.left - sw.left - padX}px`);
    blob.style.setProperty("--translateY", `${tg.top  - sw.top  - padY}px`);
    blob.style.setProperty("--width",      `${tg.width}px`);
    blob.style.setProperty("--height",     `${tg.height}px`);
    blob.style.setProperty("--scale",      scale);
  }

  // 6) Initial render & animation
  moveBlob(current);
  animateCards(cards);

  // 7) Wire events
  items.forEach(btn => {
    btn.addEventListener("click", () => {
      items.forEach(i => i.classList.remove("active"));
      btn.classList.add("active");
      current = btn;

      // filter cards
      const sel = btn.dataset.origin;
      const visible = cards.filter(card => {
        const o = card.dataset.origin.trim().toLowerCase();
        const show = sel === "all" || o === sel;
        card.style.display = show ? "grid" : "none";
        return show;
      });

      moveBlob(btn, 1);
      animateCards(visible);
    });

    btn.addEventListener("mouseenter", () => moveBlob(btn, 1.1));
    btn.addEventListener("mouseleave", () => moveBlob(current, 1));
  });
}
